import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1616.87467,1813.33333 C1589.248,993.066667 926.954667,330.773333 106.688,303.146667 L106.688,107.52 C1034.90133,135.253333 1784.768,885.12 1812.50133,1813.33333 L1616.87467,1813.33333 Z M53.3546667,0 L0.0213333333,0 L0.0213333333,408.853333 L53.3546667,408.853333 C857.088,408.853333 1511.06133,1062.82667 1511.06133,1866.66667 L1511.06133,1920 L1920.02133,1920 L1920.02133,1866.66667 C1920.02133,837.44 1082.58133,0 53.3546667,0 L53.3546667,0 Z M987.338667,1813.33333 C960.672,1339.84 580.192,959.36 106.698667,932.586667 L106.698667,736.853333 C687.925333,763.946667 1155.97867,1232.10667 1183.072,1813.33333 L987.338667,1813.33333 Z M53.3653333,628.906667 L0.032,628.906667 L0.032,1037.76 L53.3653333,1037.76 C510.325333,1037.76 882.165333,1409.70667 882.165333,1866.66667 L882.165333,1920 L1291.01867,1920 L1291.01867,1866.66667 C1291.01867,1184.21333 735.818667,628.906667 53.3653333,628.906667 L53.3653333,628.906667 Z M267.189333,1812.288 C179.189333,1812.288 107.616,1740.71467 107.616,1652.82133 C107.616,1564.928 179.189333,1493.35467 267.189333,1493.35467 C355.082667,1493.35467 426.656,1564.928 426.656,1652.82133 C426.656,1740.71467 355.082667,1812.288 267.189333,1812.288 M267.189333,1386.688 C120.416,1386.688 0.949333333,1506.048 0.949333333,1652.82133 C0.949333333,1799.59467 120.416,1918.95467 267.189333,1918.95467 C413.962667,1918.95467 533.322667,1799.59467 533.322667,1652.82133 C533.322667,1506.048 413.962667,1386.688 267.189333,1386.688",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconRssLine = /*#__PURE__*/function (_Component) {
  _inherits(IconRssLine, _Component);

  var _super = _createSuper(IconRssLine);

  function IconRssLine() {
    _classCallCheck(this, IconRssLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconRssLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconRss",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconRssLine.displayName = "IconRssLine";
  return IconRssLine;
}(Component);

IconRssLine.glyphName = 'rss';
IconRssLine.variant = 'Line';
IconRssLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconRssLine;
export { IconRssLine };